import { useQuery } from "@tanstack/react-query";
import { getTenantsHistory } from "../../api/tenants";

function useGetTenantsHistory({ propertyUid }: { propertyUid: string }) {
  const query = useQuery({
    queryKey: ["tenants-history", propertyUid],
    queryFn: () => getTenantsHistory({ propertyUid }),
    enabled: !!propertyUid,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  return { ...query, data: query.data?.data };
}

export default useGetTenantsHistory;
